// extracted by mini-css-extract-plugin
export default {"grid":"OrderList_grid__qlSoh"};